export default __webpack_public_path__ + "static/media/hotel_2.8e6908a1.png";